"use strict";
import Swiper from 'swiper';
import theme from './js/mapTheme';
import Swipe from './js/Swipe';
import smoothScroll from './js/smoothScroll';
import css from './index.css';
import translate from './js/locale';

/* Swipers */
window.addEventListener(`DOMContentLoaded`, () => {

    document.body.classList.add(`is-loaded`);

    new Swiper(`[data-swiper]`, {
        slidesPerView: `auto`,
        spaceBetween: 12,
        freeMode: true,
        initialSlide: 5,
        centeredSlides: true,
        grabCursor: true,
        loop: true,
    });
    new Swiper(`[data-strip]`, {
        slidesPerView: `auto`,
        spaceBetween: 0,
        freeMode: true,
        grabCursor: true,
        loop: true,
    });

    new Swiper(`[data-blog]`, {
        slidesPerView: 2,
        spaceBetween: 24,
        breakpoints: {640: {slidesPerView: `auto`, spaceBetween: 17, centeredSlides: true}},
    });

    const groupsHolder = document.querySelector(`.menu__groups`);
    const groups = groupsHolder ? groupsHolder.dataset.groups.split(`;`) : [];

    new Swiper(`[data-menu]`, {
        centeredSlides: true,
        loop: true,
        autoHeight: true,
        breakpoints: {640: {slidesPerView: `auto`, spaceBetween: 17}},
        pagination: {
            el: `.menu__groups`,
            bulletClass: `menu__group`,
            bulletActiveClass: `menu__group--active`,
            clickable: true,
            renderBullet(idx, className) {
                return `<li class="${className}">${groups[idx]}</li>`;
            },
        },
    });

    // Product swiper
    const pagination = document.querySelectorAll(`.products__pagination .box`);
    [...pagination].forEach((item, index) => item.addEventListener(`click`, () => {
        productsSlider.slideToLoop(index);
    }));
    const prevButton = document.querySelector(`.products__prev a`);
    prevButton && prevButton.addEventListener(`click`, e => {
        e.preventDefault();
        productsSlider.slidePrev();
    });
    const nextButton = document.querySelector(`.products__next a`);
    nextButton && nextButton.addEventListener(`click`, e => {
        e.preventDefault();
        productsSlider.slideNext();
    });

    const productsSlider = new Swiper(`[data-products]`, {
        centeredSlides: true,
        loop: true,
        breakpoints: {640: {slidesPerView: `auto`, spaceBetween: 17}},
        autoplay: {
            delay: 7500,
        },
        on: {
            slideChange() {
                [...pagination].forEach(item => item.classList.remove(`active`));
                const current = pagination[this.realIndex] || pagination[0];
                const prev = current.previousElementSibling;
                const next = current.nextElementSibling;
                const last = pagination[pagination.length - 1];
                const first = pagination[0];
                current.classList.add(`active`);
                prevButton.innerHTML = prev ? prev.querySelector(`h3`).innerHTML : last.querySelector(`h3`).innerHTML;
                nextButton.innerHTML = next ? next.querySelector(`h3`).innerHTML : first.querySelector(`h3`).innerHTML;
            },
            init() {
                const current = pagination[this.realIndex] || pagination[0];
                current.classList.add(`active`);
            },
        },
    });

});

/*Ajax form*/
[...document.querySelectorAll(`form.ajax`)].forEach(form => {
    form.addEventListener(`submit`, e => {
        e.preventDefault();
        const errors = validateForm(form);

        if (errors.length === 0) {
            const request = new XMLHttpRequest();

            request.onreadystatechange = function() {
                // Loading
                if (this.readyState < XMLHttpRequest.DONE) {
                    form.classList.add(`form--loading`);
                }
                // Success
                if (this.readyState === XMLHttpRequest.DONE && this.status === 200) {
                    form.classList.add(`form--success`);
                    form.classList.remove(`form--loading`);
                    setTimeout(() => form.classList.remove(`form--success`), 3000);
                    form.reset();
                }
                // Failure
                if (this.readyState === XMLHttpRequest.DONE && this.status !== 200) {
                    form.classList.add(`form--failure`);
                    setTimeout(() => form.classList.remove(`form--failure`), 3000);
                    form.classList.remove(`form--loading`);
                }
            };

            request.open(`POST`, form.action);
            request.setRequestHeader(`X-Requested-With`, `XMLHttpRequest`);
            request.send(new FormData(form));

        } else {
            alert(errors.join(`\n`));
        }
    });
});

function validateForm(form) {
    const errors = [];
    const date = form.querySelector(`[name="date"]`);
    const time = form.querySelector(`[name="time"]`);
    if (!date || !date.value || !time || !time.value)
        return [translate(`dateNotFilled`)];
    const dateObject = new Date(`${date.value} ${time.value}`);
    const fiveHours = 18000000;
    if (dateObject.valueOf() < Date.now() + fiveHours)
        errors.push(translate(`dateNotFuture`));
    return errors;
}

/*Menu toggle*/
new Swipe(document.querySelector(`.header__container`), (e, dir) => {
    dir === `left` && document.body.classList.remove(`is-open`);
});
document.querySelector(`[data-toggle]`).addEventListener(`click`, e => {
    document.body.classList.toggle(`is-open`);
});

/*Modals*/
document.querySelectorAll(`[data-modal]`).forEach(item => {
    item.addEventListener(`click`, e => {
        const id = e.currentTarget.dataset.modal;
        document.getElementById(id).classList.toggle(`modal--active`);
        document.body.classList.add(`with-modal`);
    });
});

[...document.querySelectorAll(`.modal__background`)].forEach(item => {
    item.addEventListener(`click`, () => {
        item.parentNode.classList.remove(`modal--active`);
        document.body.classList.remove(`with-modal`);
    });
});

[...document.querySelectorAll(`.modal__close`)].forEach(item => {
    item.addEventListener(`click`, () => {
        item.parentNode.parentNode.classList.remove(`modal--active`);
        document.body.classList.remove(`with-modal`);
    });
});

/*Google map*/
window.initMap = () => {
    const place = {lat: 50.107807, lng: 14.353897};
    // eslint-disable-next-line
    const map = new google.maps.Map(document.querySelector(`.map`), {
        zoom: 15,
        center: place,
        styles: theme,
        disableDefaultUI: true,
    });
    // eslint-disable-next-line
    const marker = new google.maps.Marker({
        position: place,
        map,
        icon: {
            url: `${location.origin}/images/marker.png`,
            // eslint-disable-next-line
            anchor: new google.maps.Point(30, 30)
        },
    });
};

/*Share*/
[...document.querySelectorAll(`.share`)].forEach(item => {
    item.addEventListener(`click`, (e) => {
        e.preventDefault();
        const url = `https://www.facebook.com/sharer/sharer.php?u=${item.dataset.url}`;
        window.open(url, ``, `menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=300,width=600`);
        return false;
    });
});

/* SmoothScroll */
[...document.querySelectorAll(`a[href^="#"]`)]
    .filter(item => item.href.split(`#`)[1].length > 0)
    .forEach(item => {
        const element = document.getElementById(item.href.split(`#`)[1]);
        item.addEventListener(`click`, e => {
            e.preventDefault();
            smoothScroll(element);
        });
    });


/* Breaking news */
[...document.querySelectorAll(`[data-news]`)].forEach(item => {
    const close = item.querySelector(`[data-close]`);
    const button = item.querySelector(`[data-button]`);
    const newsId = item.dataset.news;
    const read = () => {
        setCookie(`festina-news`, newsId, 365);
        item.classList.add(`is-hidden`);
    };

    close.addEventListener(`click`, read);
    button.addEventListener(`click`, read);
});

function setCookie(name, value, days) {
    const d = new Date();
    d.setTime(d.getTime() + 24 * 60 * 60 * 1000 * days);
    document.cookie = `${name}=${value};path=/;expires=${d.toGMTString()}`;
}